import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trends-page-footer',
  templateUrl: './trends-page-footer.component.html',
  styleUrls: ['./trends-page-footer.component.scss']
})
export class TrendsPageFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
